import { Fragment, useEffect } from 'react';
import { LoadScript } from '../shared/ScriptHelper';

export function ADTrek() {
    useEffect(function () {
        LoadScript('https://affiliate.adtrek.com/api/v1/tracking.js');
    });
    return <Fragment />
}